import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { DownloadLight } from '../../ui/icon/DownloadLight';

function PressImageDetails({
  pressImage,
  type,
}) {
  useEffect(() => window.initMediaelementPlayer(), []);

  if (!pressImage) {
    return null;
  }

  return (
    <div className="gallery-section">
      <div className="gallery-content-block">
        <div className={`gallery-holder ${type === 'public' ? 'w-100' : 'me-6'}`}>
          {pressImage.pressImage && (
            <img
              src={pressImage.pressImage.transforms.pressImageLg.url}
              alt={pressImage.alt || pressImage.title}
            />
          )}
        </div>
        {type === 'private' && (
          <div className="gallery-content-info">
            {pressImage.fair && (
              <div className="mb-2 mb-md-3">
                <span className="h6 text-muted fw-normal d-block">
                  Fair
                </span>
                <span className="info-product">
                  {pressImage.fair[0].title}
                </span>
              </div>
            )}
            {pressImage.gallery && (
              <div className="mb-2 mb-md-3">
                <span className="h6 text-muted fw-normal d-block">
                  Gallery
                </span>
                <span className="info-product">
                  {pressImage.gallery[0].title}
                </span>
              </div>
            )}
            {pressImage.artCategories && (
              <div className="mb-2 mb-md-3">
                <span className="h6 text-muted fw-normal d-block">
                  Art category
                </span>
                <span className="info-product">
                  {pressImage.artCategories[0].title}
                </span>
              </div>
            )}
            {(pressImage.period) && (
              <div className="mb-2 mb-md-3">
                <span className="h6 text-muted fw-normal d-block">
                  Period
                </span>
                <span className="info-product">
                  {pressImage.period[0].title}
                </span>
              </div>
            )}
            {pressImage.artist && (
              <div className="mb-2 mb-md-3">
                <span className="h6 text-muted fw-normal d-block">
                  Artist
                </span>
                <span className="info-product">
                  {pressImage.artist}
                </span>
              </div>
            )}
          </div>
        )}
      </div>
      <div className="gallery-content-block pt-2">
        <div className="gallery-content-info">
          {pressImage.pressImageCaption && (
            <div className="mb-2 mb-md-3">
              <span className="figure-caption">
                {pressImage.pressImageCaption}
              </span>
            </div>
          )}
          <a href={pressImage.pressImage.url} className="press-release-pack__button" target="_blank" rel="noreferrer" download>
            <DownloadLight />
            Download image
          </a>
        </div>
      </div>
    </div>
  );
}

export { PressImageDetails };

PressImageDetails.propTypes = {
  pressImage: PropTypes.oneOfType([PropTypes.object]),
  type: PropTypes.string.isRequired,
};

PressImageDetails.defaultProps = {
  pressImage: null,
};
